/* --------------------------------------------------------------------------------------
   redirect.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const redirectComponent = {
  template: `
  `,
  controllerAs: "vm",
  controller: class ssoCallbackCtrl {
    /* @ngInject */
    constructor(ssoClientService) {
      this.ssoClientService = ssoClientService;
    }
    async $onInit() {
      window.location.href = this.ssoClientService.getRedirectUrl();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/redirect.component.js